import React from 'react';
import './OracleCourses.css';
import { useState } from 'react';
import { Pagination } from '@mui/material';
import usePagination from '../sap-components/pagination';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import OracleCoursesData from './data/courses.json'
import OracleQuickLinks from './components/QuickLinks'
import HangingMenus from './components/HangingMenus';
import OracleNavBar from './OracleNavBar';

const OracleCourses = (props) => {
  var arr = [];
  
  const courseNames = ["Datawarehousing","Datamodelling","Data Lake Evaluation","Datalake on AWS","Data Warehousing with Azure: Managing Azure Data Lake","Cloud Essentials"];
  
  let cCode = '';
  if(Object.keys(props.match.params).length > 0)
    cCode = props.match.params.code;

  const [coursedata, setCourseData] = useState(OracleCoursesData);
  const [searching, setSearching] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [dropDownFilter, setDropDownFilter] = useState([]);
  const [dropDownFilter1, setDropDownFilter1] = useState([]);
  const [page, setPage] = useState(1);
  const PER_PAGE = 6;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const [selected1, setSelected1] = useState('');
  const [modalContent, setModalContent] = useState({});  

  const count = Math.ceil(coursedata.length / PER_PAGE);
  const _DATA = usePagination(coursedata, PER_PAGE);
  const count1 = Math.ceil(filteredResults.length / PER_PAGE);
  const _DATA1 = usePagination(filteredResults, PER_PAGE);
  const count2 = Math.ceil(dropDownFilter.length / PER_PAGE);
  const _DATA2 = usePagination(dropDownFilter, PER_PAGE);
  const count3 = Math.ceil(dropDownFilter1.length / PER_PAGE);
  const _DATA3 = usePagination(dropDownFilter1, PER_PAGE);

  const courseCount = Math.ceil(filteredResults.length);
  const courseCount1 = Math.ceil(dropDownFilter.length);
  const courseCount2 = Math.ceil(dropDownFilter1.length);

  if (cCode !== '') {
    arr = coursedata.find(course => {
      return course.sno == cCode;
    });
  }

  const handleOpen = sno => {
    setOpen(true);  
    const clickedCourseDetail = OracleCoursesData.filter((obj) => {            
      return obj.sno === sno;
    })      
    setModalContent(clickedCourseDetail[0]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let dropdownFiltering = [];
  let dropdownFiltering1 = [];
  const eventChange = e => {
    return setSearching(e.target.value);
  };
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p) ? _DATA.jump(p) : _DATA1.jump(p);
  };
  const handleChange1 = (e, p) => {
    setPage(p);
    _DATA2.jump(p);
  };
  const handleChange2 = (e, p) => {
    setPage(p);
    _DATA3.jump(p);
  };
  const handleEnterSearch = (e) => {
      if(e.key === 'Enter') {
          e.preventDefault();
          searchData();
      }        
  }
  const searchData = () => {
    if (searching !== '' && dropDownFilter1.length > 0 && dropDownFilter.length > 0) {
      const filteredData = dropDownFilter1.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '' && dropDownFilter.length > 0) {
      const filteredData = dropDownFilter.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '' && dropDownFilter1.length > 0) {
      const filteredData = dropDownFilter1.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '') {
      const filteredData = coursedata.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    }
  };

  const changeDomain = event => {
    setSelected(event.target.value);
    coursedata.forEach(elem => {
      if (elem.Domain === event.target.value) {
        dropdownFiltering.push({
          ...elem
        });
      }
    });
    setDropDownFilter(dropdownFiltering);
  };
  const changeSpecialization = event => {
    setSelected1(event.target.value);
    coursedata.forEach(elem => {
      if (elem.Specialization === event.target.value) {
        dropdownFiltering1.push({
          ...elem
        });
      }
    });
    setDropDownFilter1(dropdownFiltering1);
  };

  let domainList = [];
  Array.from(new Set(coursedata.map(obj => obj.Domain))).map(Domain => {
    return domainList.push({ key: Domain, label: Domain });
  });

  const resetSearch = () => {
    setDropDownFilter([]);
    setDropDownFilter1([]);
    setFilteredResults([]);
    setSearching('');
    setSelected('');
    setSelected1('');
  };
  const allData = data => {
    console.log('1');
    console.log(data['course_image']);
    console.log('2');
    let bgImage = require('../images/Oracle/' + data['course_image'] + '.png');
    return (
      <>
        <div className="main_card_container" key={data['Course_Name']}>
          <div className="sub_cart_container">
            <div className="img_container" style={{ backgroundImage: `url(${bgImage})` }}>
              <span>{data['Course_Name']}</span>
            </div>
            <div className="card_content">
              <div className="cardText">
                <div>
                  <span className="prerequisite_label">Course Code: </span>
                  <span className="prerequisite_text"> {data['Course_Code']} </span>
                </div>
                <div className="sourseInfo">
                  <p
                    className="courseInfoText"
                    dangerouslySetInnerHTML={{
                      __html: data['Description-Bulleted']
                    }}
                  ></p>
                </div>

                <Modal
                  hideBackdrop
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="child-modal-title"
                  closeAfterTransition
                  aria-describedby="child-modal-description"
                >
                  <Box className="model">
                    <div className="model_heading">
                      <h3 className="paramodel">{modalContent['Course_Name']}</h3>
                      <span className="close_btn_model" onClick={handleClose}>
                        Close
                      </span>
                    </div>
                    <hr />
                    <div className="mainRootWrapper">
                      <div>
                        <h4>Domain</h4>
                        <p>{modalContent.Domain}</p>
                      </div>
                      <div>
                        <h4>Specialization</h4>
                        <p>{modalContent.Specialization}</p>
                      </div>
                      <div>
                        <h4>Prerequisite</h4>
                        <p>{modalContent['Pre-requisite']}</p>
                      </div>
                     
                        <p>
                        <span className='card_icon_wrapper1'>
                        <img src={process.env.PUBLIC_URL + '/images/SAP/duration_icon.png'} alt="SVG as an img" />
                          <span>{modalContent['Duration']}h</span>
                        </span>
                        
                        <span className='card_icon_wrapper'>
                        <img src={process.env.PUBLIC_URL + '/images/SAP/mode_icon.png'} alt="SVG as an img" />
                        <span className="mode-text">{modalContent['Mode']}</span>
                        </span>
                      </p>
                    </div>
                    <div className="mainRootWrapper1">
                      <div>
                        <h4>
                          Course Code <br /> {modalContent['Course_Code']}
                        </h4>
                      </div>

                      <div>
                        <h4>Skill Name</h4>
                        <p>{modalContent['SSI_Skill_Name']}</p>
                      </div>
                      <div>
                        <h4>Course Level</h4>
                        <p>{modalContent['Career_Levels']}</p>
                      </div>
                      <div>
                        <h3 className="model_link">                          
                          {courseNames.includes(modalContent['Course_Name']) ?<a href={modalContent.Mylearning_URL} target="_blank" rel="noreferrer">                            
                            Go to myLearning
                          </a>: 
                          <a href={modalContent.Mylearning_URL} target="_blank" rel="noreferrer">
                            Go to ULS              
                          </a>}
                        </h3>
                      </div>
                    </div>
                    <h4 className="model_descrip">Description</h4>
                    <p className="model_desrcip_data">{modalContent['Description']}</p>
                    <div>
                      <h4>Learning Outcomes</h4>
                      <p>{modalContent['Learning_Outcomes']}</p>
                    </div>
                  </Box>
                </Modal>
                <div className="prerequisite-block">
                  <span className="prerequisite_label">Prerequisite: </span>
                  <span className="prerequisite_text"> {data['Pre-requisite']} </span>
                </div>
                <div className="prerequisite-block">
                  <span className="prerequisite_label">Skill Name: </span>
                  <span className="prerequisite_text"> {data['SSI_Skill_Name']} </span>
                </div>
                <div className="open_btn_model" onClick={() => handleOpen(data['sno'])}>
                  Show more
                </div>
              </div>
              <div className="card_icon">
                <div className="card_icon_wrapper">
                  <img src={process.env.PUBLIC_URL + '/images/SAP/mode_icon.png'} alt="SVG as an img" />
                  <span className="mode-text">{data['Mode']}</span>
                </div>
                <div className="card_icon_wrapper1">
                  <img src={process.env.PUBLIC_URL + '/images/SAP/duration_icon.png'} alt="SVG as an img" />
                  <span className="duration-text">{data['Duration']}h</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <OracleNavBar />
      <div id="main_container" className="sap_main_container">
      < div id="main_container">
      <div className='banner-container'>
    <img src={process.env.PUBLIC_URL + '/images/Oracle/Oracle-Banner.png'} alt='Oracle-banner' className='img-responsive'/>
      </div>
    </div>

        <div className="section_container">
          <div className="banner-content">
            <p>
            Explore here to amplify your skills on Oracle career through L&TT Oracle experiential job-ready learnings that’s customized for you to excel at client delivery.
            </p>
          </div>
          <br />
          <br />
          {cCode !== '' ? (
            <h2 className="searchHeading">Oracle Course</h2>
          ) : (
            <>
              <form className="form_container d-flex searchCourses">
                <div className="searchBox1">
                  <lable className="lable_container">Domain </lable>
                  <select className="selection_container" value={selected} onChange={e => changeDomain(e)}>
                    <option selected>All</option>
                    {domainList.map(item => {
                      return (
                        <option key={item.key} value={item.key}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="searchBox2">
                  <lable className="lable_container1">Specialization </lable>
                  <select className="selection_container" value={selected1} onChange={changeSpecialization}>
                    <option className="option_container" selected>
                      All
                    </option>
                    {dropDownFilter.length > 0
                      ? Array.from(new Set(dropDownFilter.map(obj => obj.Specialization))).map(itemname => {
                          return <option value={itemname}>{itemname}</option>;
                        })
                      : Array.from(new Set(coursedata.map(obj => obj.Specialization))).map(Specialization => {
                          return (
                            <option className="option_container" value={Specialization}>
                              {Specialization}
                            </option>
                          );
                        })}
                  </select>
                </div>
                <div className="searchBox3">
                  <lable className="lable_container2">Keyword Search</lable>
                  <div className="goButton">
                    <input type="search" className="search_wrapper" onKeyPress={handleEnterSearch} onChange={eventChange} value={searching} />
                    <input className="search_btn" type="button" onClick={searchData} />
                    <input type="button" className="reset_btn" value="Reset" onClick={resetSearch} />
                  </div>
                </div>
              </form>
              <div className="course_count">
                {filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0
                  ? `${courseCount} Courses Found`
                  : dropDownFilter.length > 0 && dropDownFilter1.length > 0
                  ? `${courseCount2} Courses Found`
                  : filteredResults.length > 0 && dropDownFilter.length > 0
                  ? `${courseCount} Courses Found`
                  : filteredResults.length > 0 && dropDownFilter1.length > 0
                  ? `${courseCount} Courses Found`
                  : courseCount1 > 0
                  ? `${courseCount1} Courses Found`
                  : courseCount2 > 0
                  ? `${courseCount2} Courses Found`
                  : courseCount > 0
                  ? `${courseCount} Courses Found`
                  : ''}
              </div>{' '}
            </>
          )}
          <div className="top_container_bg">
            <div className="top_container">
              {cCode !== ''
                ? allData(arr)
                : filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0
                ? _DATA1.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : filteredResults.length > 0 && dropDownFilter.length > 0
                ? _DATA1.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : filteredResults.length > 0 && dropDownFilter1.length > 0
                ? _DATA1.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : dropDownFilter.length > 0 && dropDownFilter1.length > 0
                ? _DATA3.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : dropDownFilter1.length > 0
                ? _DATA3.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : dropDownFilter.length > 0
                ? _DATA2.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : filteredResults.length > 0
                ? _DATA1.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                : _DATA.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })}
            </div>
          </div>
          {cCode !== '' ? (
            ''
          ) : filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : dropDownFilter.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count3}
              size="large"
              page={page}
              onChange={handleChange2}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 && dropDownFilter.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : dropDownFilter1.length > 0 ? (
            <Pagination
              count={count3}
              size="large"
              page={page}
              onChange={handleChange2}
              className="pagination_container"
            />
          ) : dropDownFilter.length > 0 ? (
            <Pagination
              count={count2}
              size="large"
              page={page}
              onChange={handleChange1}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : (
            <Pagination
              count={count}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          )}
        </div>
      </div>
      <HangingMenus />
      <OracleQuickLinks />
    </>
  );
};
export default OracleCourses;